import {
  FormControl, InputLabel, MenuItem, Select, Tooltip, Box,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import React from 'react';

export function ChooseOne(props: {
  label: string;
  helpText?: string;
  options: (
    string | {
      value: string;
      label: React.ReactNode;
    })[];
} & ({
  isRequired?: true;
  onChange: (value: string) => void;
  value?: string;
} | {
  isRequired?: false;
  onChange: (value: string | null) => void;
  value?: string | null;
})) {
  const {
    label, helpText, options, value, onChange, isRequired = false,
  } = props;

  return (
    <FormControl
      variant="standard"
      sx={{
        width: '100%',
        ...(helpText && { position: 'relative' })
      }}
    >
      <InputLabel
        shrink
      >
        {label}
      </InputLabel>
      <Select
        fullWidth
        value={value}
        onChange={(e) => {
          onChange(e.target.value as any);
        }}
        required={isRequired}
        sx={{
          borderWidth: 0,
          borderBottomWidth: 1,
        }}
      >
        {isRequired ? null : (
          <MenuItem value="">
            None
          </MenuItem>
        )}
        {options.map((option) => {
          const optionValue = typeof option === 'string' ? option : option.value;
          const optionLabel = typeof option === 'string' ? option : option.label;
          return (
            <MenuItem
              key={optionValue}
              value={optionValue}
            >
              {optionLabel}
            </MenuItem>
          );
        })}
      </Select>
      {helpText && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            pointerEvents: 'auto',
            zIndex: 1
          }}
        >
          <Tooltip title={helpText}>
            <HelpOutlineIcon
              sx={{
                fontSize: 16,
                color: 'text.secondary',
                cursor: 'pointer'
              }}
            />
          </Tooltip>
        </Box>
      )}
    </FormControl>
  );
}
